export default `outgoingLight *= vAO;
#include <opaque_fragment>`